import React, { useState } from "react";
import Image from "react-bootstrap/Image";
import { Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { IMAGES } from "../../../assets/images/images";
import { Icon } from "@iconify/react";
import { Formik, Field, ErrorMessage, Form } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import { Loginuser } from "../../../utility/apiServices/userServices";
import { setLocalStorage } from "../../../utility/local/functions/setlocalStorage";
import GoogleLoginButton from "./auth/GoogleLoginButton";

// Validation schema


const UserLogin = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const LoginSchema = Yup.object().shape({
    email: Yup.string()
      .email(t("login.invalid_email"))
      .required(t("login.email_required")),
    password: Yup.string().required(t("login.password_required")),
  });
  const handleSubmit = async (values, { setSubmitting }) => {
    console.log("values :", values);
    try {
      const response = await Loginuser({
        email: values.email,
        password: values.password,
      });
      if (response?.status) {
        setLocalStorage(
          response?.accessToken,
          response?.refreshToken,
          response?.user
        );
        navigate("/");
      } else {
        Swal.fire({
          icon: "error",
          text: response?.message || t("login.error_message"),
        });
      }
    } catch (error) {
      console.error("Login error", error);
      Swal.fire({
        icon: "error",
        text: t("login.general_error"),
      });
    }
    setSubmitting(false);
  };

  return (
    <section className="login_box">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-md-6 hideloginimg">
            <div className="login_bg">
              <Image src={IMAGES.Login_Bg} className="img-fluid" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="loginBody">
              <Formik
                initialValues={{ email: "", password: "" }}
                validationSchema={LoginSchema}
                onSubmit={handleSubmit}
              >
                {({ isSubmitting, errors }) => (
                  <Form>
                    <h1>{t("login.welcome")}</h1>
                    <p className="para">{t("login.description")}</p>

                    <div className="mb-3">
                      <label htmlFor="email">{t("login.email")}</label>
                      <Field
                        name="email"
                        type="email"
                        placeholder={t("login.email_placeholder")}
                        className="form-control"
                      />
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="errorStyle"
                      />
                    </div>

                    <div className="mb-3">
                      <label htmlFor="password">{t("login.password")}</label>
                      <div className="position-relative">
                        <Field
                          name="password"
                          type={showPassword ? "text" : "password"}
                          placeholder={t("login.password_placeholder")}
                          className="form-control"
                        />
                        <button
                          type="button"
                          onClick={() => setShowPassword(!showPassword)}
                          className="password-toggle-btn"
                          style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            border: "none",
                            background: "transparent",
                            cursor: "pointer",
                            padding: "5px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Icon
                            icon={showPassword ? "mdi:eye-off" : "mdi:eye"}
                            fontSize={20}
                            color="#666"
                          />
                        </button>
                      </div>
                      <ErrorMessage
                        name="password"
                        component="div"
                        className="errorStyle"
                      />
                    </div>

                    <div className="text-end">
                      <Link to="/forgotpassword" className="forgotPassword">
                        {t("login.forgot_password")}
                      </Link>
                    </div>

                    {errors.general && (
                      <div className="errorStyle">{errors.general}</div>
                    )}

                    <Button
                      type=""
                      disabled={isSubmitting}
                      className="btn btn-primary my-3 mb-4 my-mb-3 mb-md-3 my-lg-3"
                    >
                      {isSubmitting ? t("login.signing_in") : t("login.sign_in")}
                    </Button>

                    <p className="text-center">
                      {t("login.no_account")}{" "}
                      <Link
                        to="/user-signup"
                        className="forgotPassword forgotPassword1"
                      >
                        {t("login.sign_up")}
                      </Link>
                    </p>

                    <div className="orBox">
                      <span>{t("login.or")}</span>
                    </div>

                    <div className="loginSocial">
                      <Link>
                        <Icon icon="logos:facebook" fontSize={24} />
                      </Link>
                      <GoogleLoginButton
                        data={{
                          account_type: "user",
                          is_influencer: false,
                        }}
                      />
                      <Link>
                        <Icon
                          icon="ic:baseline-apple"
                          color="#000000"
                          fontSize={30}
                        />
                      </Link>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UserLogin;
